<template>
    <b-col col
           lg="3"
           id="section_menu"
           class="section-menu"
           :class="{'active' : mobileMenu}">
        <div class="section-menu-title desktop-only">
            <h3 v-html="title"></h3>
        </div>
        <div class="section-menu-inner">
            <ul class="section-menu-list">
                <section-menu-item v-for="(item, index) in menu"
                                   :item="item"
                                   :key="index"
                                   :index="index"
                                   :active="active"
                                   :no-packet="item.noPacket ? true : false"
                                   :no-packet-path="item.noPacketPath"
                                   :mobile-only="item.mobileOnly"
                                   :lv2="item.lv2 ? item.lv2 : false"
                ></section-menu-item>
            </ul>
        </div>
    </b-col>
</template>

<script>
    import SectionMenuItem from './item/SectionMenuItem.vue'

    export default {
        components: { SectionMenuItem },
        props: ['active', 'title'],
        data () {
            return {
                menu: {
                    dashboard: {
                        name: 'Dashboard',
                        path: 'Dashboard',
                        noPacketPath: 'StartPacket',
                        noPacket: true
                    },
                    withdraw: {
                        name: 'Withdraw',
                        path: 'Withdraw',
                        noPacketPath: 'Withdraw',
                        noPacket: true
                    },
                    futurocoin: {
                        name: 'Futurocoin',
                        path: 'Futurocoin',
                        noPacket: true
                    },
                    myStartPacket: {
                        name: 'My start package',
                        path: 'MyStartPacket',
                        parentClickable: true,
                        lv2: {
                            invoices: {
                                name: 'Invoices',
                                path: 'Invoices',
                                external: false
                            }
                        }
                    },
                    business: {
                        name: 'Business',
                        path: 'Business',
                        lv2: {
                            qualifications: {
                                name: 'Qualifications',
                                path: 'BusinessQualifications',
                                external: false
                            },
                            commissions: {
                                name: 'Commissions',
                                path: 'BusinessCommissions',
                                external: false
                            },
                            codes: {
                                name: 'Vouchers',
                                path: 'Codes',
                                external: false,
                            }
                        }
                    },
                    myTeam: {
                        name: 'My team',
                        path: 'MyTeam'
                    },
                    payout: {
                        name: 'Payout',
                        path: 'Payout'
                    },
                    sponsorSystem: {
                        name: 'Sponsor system',
                        path: 'SponsorSystem'
                    },
                    news: {
                        name: 'News',
                        path: 'News'
                    },
                    topQualified: {
                        name: 'Top Qualified',
                        path: 'TopQualified'
                    },
                    profile: {
                        name: 'Profile',
                        path: 'Profile',
                        mobileOnly: true,
                        noPacket: true,
                    },
                    terms: {
                        name: 'Terms of Use',
                        path: 'Terms',
                        noPacket: true,
                        parentClickable: false,
                        lv2: {
                            terms: {
                                name: 'Terms ans Conditions',
                                path: '/static/media/terms-and-conditions.pdf',
                                external: true
                            },
                            commissions: {
                                name: 'Privacy Policy',
                                path: '/static/media/privacy-policy.pdf',
                                external: true
                            }
                        }
                    },
                    logout: {
                        name: 'Logout',
                        path: 'Logout',
                        mobileOnly: true,
                        noPacket: true
                    }
                }
            }
        },
        computed: {
            mobileMenu () {
                return this.$store.getters.mobileMenu
            }
        }
    }
</script>

<style lang="scss" scoped>
    @media(min-width: 992px) {
        .section-menu{
            margin-top: -130px;
        }
    }
    @media(max-width: 991px){
        .section-menu{
            padding: 0;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/layout/partials/section/menu/MainMenu.vue